import { GUID } from '../../helpers/guid.helper';

export class AddEmployeeDto {
    // person data
    Id: string;
    FirstName: string;
    LastName: string;
    Alias: string;
    DocumentNumber: string;
    PhoneNumber: string;
    MobilePhoneNumber: string;
    AnotherContactPhone: string;
    Birthdate: string;
    Photo: string;
    IdentificationTypeId: number;
    PersonGenderId: number;
    Address: string;
    IsActive: boolean;
    // staff data
    CUIL: string;
    Email: string;
    Title: string;
    PostTitle: string;
    PostGraduateCourse: string;
    OtherTrainings: string;
    HireDate: string;
    TeachingStarDate: string;
    RelationshipId: number;
    PhoneNumberEmergencyContact: string;
    EmergencyContact: string;
    JobTitles: JobTitleData[];

    constructor() {
        this.Id = GUID.newGuid();
        this.FirstName = '';
        this.LastName = '';
        this.Alias = '';
        this.DocumentNumber = '';
        this.PhoneNumber = '';
        this.MobilePhoneNumber = '';
        this.AnotherContactPhone = '';
        this.Birthdate = '';
        this.Photo = '';
        this.IdentificationTypeId = -1;
        this.PersonGenderId = -1;
        this.Address = '';
        this.IsActive = true;
        this.JobTitles = [];
        this.Title = '';
        this.PostTitle = '';
        this.PostGraduateCourse = '';
        this.OtherTrainings = '';
        this.EmergencyContact = '';
        this.RelationshipId = 0;
        this.PhoneNumberEmergencyContact = '';
    }
}

export class JobTitleData {
    JobTitleId: number;
    ShiftId: number;
    TypeEmployeeId: number;
    Workload: number;

    constructor() {
        this.JobTitleId = null;
        this.ShiftId = null;
        this.TypeEmployeeId = null;
        this.Workload = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/employee/add-employee-dto.ts